import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Package, Truck, CheckCircle2, MapPin, Clock, AlertCircle } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { useVendor } from '../context/VendorContext';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function VendorDeliveryScreen() {
  const {
    orders
  } = useVendor();
  const [activeTab, setActiveTab] = useState<'Active' | 'Completed' | 'All'>('Active');
  const deliveries = orders.filter(o => {
    if (activeTab === 'Active') return o.orderStatus === 'Shipped';
    if (activeTab === 'Completed') return o.orderStatus === 'Delivered';
    return true;
  });
  return <div className="min-h-full bg-gray-50 dark:bg-gray-900 pb-10" data-id="element-1789">
      <Header title="Logistics & Delivery" showBack data-id="element-1790" />

      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-10" data-id="element-1791">
        <div className="flex" data-id="element-1792">
          {['Active', 'Completed', 'All'].map(tab => <button key={tab} onClick={() => setActiveTab(tab as any)} className={`flex-1 py-4 text-sm font-medium border-b-2 transition-colors ${activeTab === tab ? 'border-primary text-primary' : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} data-id="element-1793">
              {tab}
            </button>)}
        </div>
      </div>

      <div className="p-4 space-y-4" data-id="element-1794">
        {deliveries.length === 0 ? <div className="text-center py-12" data-id="element-1795">
            <Truck className="w-16 h-16 text-gray-300 dark:text-gray-600 mx-auto mb-4" data-id="element-1796" />
            <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1797">
              No deliveries found
            </h3>
            <p className="text-gray-500 dark:text-gray-400 mt-1" data-id="element-1798">
              You don't have any {activeTab.toLowerCase()} deliveries.
            </p>
          </div> : deliveries.map(delivery => <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} key={delivery.id} className="bg-white dark:bg-gray-800 rounded-2xl p-4 shadow-sm border border-gray-100 dark:border-gray-700" data-id="element-1799">
              <div className="flex justify-between items-start mb-4" data-id="element-1800">
                <div data-id="element-1801">
                  <div className="text-xs text-gray-500 dark:text-gray-400 mb-1" data-id="element-1802">
                    Order #{delivery.id}
                  </div>
                  <div className="font-semibold text-gray-900 dark:text-white" data-id="element-1803">
                    {delivery.buyerName}
                  </div>
                </div>
                <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${delivery.orderStatus === 'Delivered' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' : 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'}`} data-id="element-1804">
                  {delivery.orderStatus}
                </span>
              </div>

              <div className="flex items-start gap-3 mb-4 bg-gray-50 dark:bg-gray-900 p-3 rounded-xl" data-id="element-1805">
                <MapPin className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-1806" />
                <div data-id="element-1807">
                  <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1808">
                    Delivery Address
                  </div>
                  <div className="text-sm font-medium text-gray-900 dark:text-white mt-0.5" data-id="element-1809">
                    {delivery.shippingAddress}
                  </div>
                </div>
              </div>

              {/* Status Tracker */}
              <div className="relative pl-6 space-y-4 mb-6" data-id="element-1810">
                <div className="absolute left-2.5 top-2 bottom-2 w-0.5 bg-gray-200 dark:bg-gray-700" data-id="element-1811"></div>

                <div className="relative z-10 flex items-center gap-3" data-id="element-1812">
                  <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center -ml-[1.1rem]" data-id="element-1813">
                    <CheckCircle2 className="w-3 h-3 text-white" data-id="element-1814" />
                  </div>
                  <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1815">
                    Picked Up
                  </div>
                </div>
                <div className="relative z-10 flex items-center gap-3" data-id="element-1816">
                  <div className="w-5 h-5 rounded-full bg-primary flex items-center justify-center -ml-[1.1rem]" data-id="element-1817">
                    <CheckCircle2 className="w-3 h-3 text-white" data-id="element-1818" />
                  </div>
                  <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1819">
                    In Transit
                  </div>
                </div>
                <div className="relative z-10 flex items-center gap-3" data-id="element-1820">
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center -ml-[1.1rem] ${delivery.orderStatus === 'Delivered' ? 'bg-primary' : 'bg-white dark:bg-gray-800 border-2 border-primary'}`} data-id="element-1821">
                    {delivery.orderStatus === 'Delivered' && <CheckCircle2 className="w-3 h-3 text-white" data-id="element-1822" />}
                  </div>
                  <div className={`text-sm font-medium ${delivery.orderStatus === 'Delivered' ? 'text-gray-900 dark:text-white' : 'text-primary'}`} data-id="element-1823">
                    Out for Delivery
                  </div>
                </div>
              </div>

              {delivery.orderStatus !== 'Delivered' && <div className="flex gap-2" data-id="element-1824">
                  <Button variant="outline" className="flex-1 border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300" data-id="element-1825">
                    Report Issue
                  </Button>
                  <Button className="flex-1 bg-primary hover:bg-primary/90 text-white" data-id="element-1826">
                    Mark Delivered
                  </Button>
                </div>}
            </motion.div>)}
      </div>
    </div>;
}